var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Button, Checkbox, Dimmer, Form, Grid, Header, Input, Loader, Message, Select, } from "semantic-ui-react";
import AddressEditForm from "./AddressForm";
import { ErrorElements } from "./kit/rna-fish/NewRnaFishKitPage";
import { is4xx } from "./CartPage";
import { ORIGIN } from "./Config";
import ErrorDisplay from "./ErrorDisplay";
import FieldWithErrorDisplay from "./FieldWithErrorDisplay";
import { Help } from "./Help";
import { getWithAuthn, postJsonWithAuthn } from "./RequestHelpers";
var ProfileEditForm = /** @class */ (function (_super) {
    __extends(ProfileEditForm, _super);
    function ProfileEditForm(props) {
        var _this = _super.call(this, props) || this;
        _this.onFirstNameChange = function (event, data) {
            _this.onProfileFieldChange('firstName', data);
        };
        _this.onLastNameChange = function (event, data) {
            _this.onProfileFieldChange('lastName', data);
        };
        _this.onEmailChange = function (event, data) {
            _this.onProfileFieldChange('email', data);
        };
        _this.onPasswordChange = function (event, data) {
            _this.onProfileFieldChange('password', data);
        };
        _this.onPhoneChange = function (event, data) {
            _this.onProfileFieldChange('phone', data);
        };
        _this.onOrganizationChange = function (event, data) {
            _this.onProfileFieldChange('organization', data);
        };
        _this.onResearchGroupChange = function (event, data) {
            _this.onProfileFieldChange('researchGroup', data);
        };
        _this.onBillingEmailChange = function (event, data) {
            _this.onProfileFieldChange('billingEmail', data);
        };
        _this.onBillingPhoneChange = function (event, data) {
            _this.onProfileFieldChange('billingPhone', data);
        };
        _this.onReferredByChange = function (event, data) {
            _this.onProfileFieldChange('referralText', data);
        };
        _this.onAcceptedTermsChange = function (event, data) {
            var newState = {
                acceptedTerms: data.checked === undefined ? false : data.checked
            };
            _this.setState(newState);
        };
        _this.onProfileFieldChange = function (key, data) {
            var value = data.value;
            var newState = {};
            newState[key] = value;
            _this.setState(newState);
        };
        _this.setShippingAddressState = function (s) {
            _this.setState(function (oldState) {
                return {
                    shippingAddress: Object.assign({}, oldState.shippingAddress, s)
                };
            }, function () {
                if (_this.state.useShippingForBilling) {
                    _this.setBillingAddressState(s);
                }
            });
        };
        _this.setBillingAddressState = function (s) {
            _this.setState(function (oldState) {
                return {
                    billingAddress: Object.assign({}, oldState.billingAddress, s)
                };
            });
        };
        _this.onUseShippingForBillingChange = function () {
            _this.setState(function (oldState) {
                return {
                    useShippingForBilling: !oldState.useShippingForBilling
                };
            }, function () {
                if (_this.state.useShippingForBilling) {
                    _this.setBillingAddressState(_this.state.shippingAddress);
                }
            });
        };
        _this.onCategoryChange = function (event, data) {
            var val = data.value;
            if (typeof val !== 'string') {
                throw new Error("Unexpected state value: " + val);
            }
            _this.setState({
                category: val
            });
        };
        _this.onSubmit = function () {
            _this.setState({
                loading: true,
                errors: [],
                success: false
            }, function () {
                var reqBody = {
                    firstName: _this.state.firstName,
                    lastName: _this.state.lastName,
                    email: _this.state.email,
                    phone: _this.state.phone,
                    legal: {
                        terms: null
                    },
                    organization: _this.state.organization,
                    researchGroup: _this.state.researchGroup,
                    shippingAddress: _this.state.shippingAddress,
                    billingAddress: _this.state.billingAddress,
                    billingEmail: _this.state.billingEmail,
                    billingPhone: _this.state.billingPhone,
                    referredBy: _this.state.referralText
                };
                if (_this.props.includePassword) {
                    reqBody.password = _this.state.password;
                }
                if (_this.props.legalInput) {
                    reqBody.legal.terms = _this.state.acceptedTerms;
                }
                if (_this.props.categoryInput) {
                    reqBody.category = _this.state.category;
                }
                if (_this.props.referredByInput) {
                    reqBody.referredBy = _this.state.referralText;
                }
                /*
                * If somehow the user tampers with the url and adds both an event referral and user referral then we
                * throw an error.
                */
                if (_this.props.eventReferral !== undefined && _this.props.userReferral !== undefined) {
                    throw new Error("event referral and user referral cannot be both undefined");
                }
                else if (_this.props.eventReferral !== undefined) {
                    reqBody.referralId = {
                        _type: 'MARKETING',
                        id: _this.props.eventReferral
                    };
                }
                else if (_this.props.userReferral !== undefined) {
                    reqBody.referralId = {
                        _type: 'PERSONAL',
                        id: _this.props.userReferral
                    };
                }
                postJsonWithAuthn(_this.props.endpoint, JSON.stringify(reqBody))
                    .then(function (resp) {
                    if (resp.ok) {
                        _this.setState({
                            loading: false,
                            success: true,
                            errors: []
                        });
                        if (_this.props.sendSignUpGaEvent) {
                            resp.json().then(function (r) {
                                gtag('event', 'sign_up', {
                                    method: 'email',
                                    user_id: r.userId
                                });
                            }).catch(function (rej) {
                                console.error("Couldn't track user sign up: " + rej);
                            });
                        }
                        return;
                    }
                    else if (resp.status === 400) {
                        return resp.json();
                    }
                    else {
                        _this.setState({
                            loading: false,
                            success: false,
                            errors: [{
                                    path: '/',
                                    msg: 'An unexpected error occurred'
                                }]
                        });
                        return;
                    }
                })
                    .then(function (resp) {
                    if (resp !== undefined) {
                        _this.setState({
                            errors: resp.errors,
                            loading: false,
                            success: false
                        });
                    }
                })
                    .catch(function (rej) {
                    // TODO exception handling -- what should we do for all these exception handlers?
                    console.error("Couldn't submit user profile: " + rej);
                });
            });
        };
        _this.loadReferringUser = function () {
            _this.setState({ loading: true }, function () {
                getWithAuthn("/user/referral-identity/" + encodeURIComponent(_this.props.userReferral))
                    .then(function (resp) {
                    if (is4xx(resp.status)) {
                        return resp.json().then(function (json) {
                            return new ErrorElements(json.errors ? json.errors : []);
                        });
                    }
                    return resp.json();
                })
                    .then(function (resp) {
                    if (resp instanceof ErrorElements) {
                        _this.setState({
                            errors: resp.errors,
                            loading: false
                        });
                    }
                    else {
                        _this.setState({
                            referralText: resp.userName,
                            loading: false
                        });
                    }
                })
                    .catch(function (rej) {
                    console.error("Couldn't load referring user " + rej);
                });
            });
        };
        _this.loadEventReferral = function () {
            _this.setState({ loading: true }, function () {
                getWithAuthn("/user/event-referral/" + encodeURIComponent(_this.props.eventReferral))
                    .then(function (resp) {
                    if (is4xx(resp.status)) {
                        return resp.json().then(function (json) {
                            return new ErrorElements(json.errors ? json.errors : []);
                        });
                    }
                    return resp.json();
                })
                    .then(function (resp) {
                    if (resp instanceof ErrorElements) {
                        _this.setState({
                            errors: resp.errors,
                            loading: false
                        });
                    }
                    else {
                        _this.setState({
                            referralText: resp.referralNote,
                            loading: false
                        });
                    }
                })
                    .catch(function (rej) {
                    console.error("Couldn't load referring event " + rej);
                });
            });
        };
        var nameArray = props.initialProfile ? props.initialProfile.name.split(" ") : [];
        _this.state = {
            loading: false,
            success: false,
            firstName: nameArray.length > 0 ? nameArray.shift() : '',
            lastName: nameArray.length > 0 ? nameArray.join(' ') : '',
            referralText: '',
            email: props.initialProfile ? props.initialProfile.email : '',
            password: '',
            phone: props.initialProfile ? props.initialProfile.phone : '',
            organization: props.initialProfile ? props.initialProfile.organization : '',
            researchGroup: props.initialProfile ? props.initialProfile.researchGroup : '',
            billingEmail: props.initialProfile ? props.initialProfile.billingEmail : '',
            billingPhone: props.initialProfile ? props.initialProfile.billingPhone : '',
            category: props.initialCategory ? props.initialCategory : '',
            shippingAddress: props.initialProfile ? props.initialProfile.shippingAddress : {
                street: '',
                streetLine2: '',
                city: '',
                stateProvince: '',
                zipPostalCode: '',
                countryCode: ''
            },
            useShippingForBilling: false,
            billingAddress: props.initialProfile ? props.initialProfile.billingAddress : {
                street: '',
                streetLine2: '',
                city: '',
                stateProvince: '',
                zipPostalCode: '',
                countryCode: ''
            },
            acceptedTerms: false,
            errors: []
        };
        return _this;
    }
    ProfileEditForm.prototype.componentDidMount = function () {
        if (this.props.userReferral !== undefined) {
            this.loadReferringUser();
        }
        if (this.props.eventReferral !== undefined) {
            this.loadEventReferral();
        }
    };
    ProfileEditForm.prototype.render = function () {
        var disabled = this.state.success && this.props.disableOnSuccess;
        return React.createElement(Dimmer.Dimmable, { as: Form, error: this.state.errors.length > 0, success: this.state.success },
            React.createElement(Dimmer, { active: this.state.loading, inverted: true },
                React.createElement(Loader, null)),
            (!this.props.hideOnSuccess || (this.props.hideOnSuccess && !this.state.success)) &&
                React.createElement("div", { className: 'profile-edit-fields' },
                    React.createElement(Header, null, "User Info"),
                    React.createElement("div", { className: 'field-group' },
                        React.createElement(Grid, { columns: 3 },
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, null,
                                    React.createElement(FieldWithErrorDisplay, { disabled: disabled, errorPath: "/firstName", errors: this.state.errors, labelContent: React.createElement(React.Fragment, null, "First Name"), required: true },
                                        React.createElement(Input, { onChange: this.onFirstNameChange, placeholder: 'Alfred', value: this.state.firstName }))),
                                React.createElement(Grid.Column, null,
                                    React.createElement(FieldWithErrorDisplay, { disabled: disabled, errorPath: "/lastName", errors: this.state.errors, labelContent: React.createElement(React.Fragment, null, "Last Name"), required: true },
                                        React.createElement(Input, { onChange: this.onLastNameChange, placeholder: 'Nobel', value: this.state.lastName }))),
                                !this.props.userReferral &&
                                    !this.props.eventReferral &&
                                    React.createElement(Grid.Column, null,
                                        React.createElement(FieldWithErrorDisplay, { disabled: disabled, errorPath: "/referredBy", errors: this.state.errors, labelContent: React.createElement(React.Fragment, null, "Referred By") },
                                            React.createElement(Input, { onChange: this.onReferredByChange, value: this.state.referralText }))),
                                this.props.userReferral
                                    &&
                                        React.createElement(Grid.Column, null,
                                            React.createElement(FieldWithErrorDisplay, { disabled: disabled, errorPath: "/referredBy", errors: this.state.errors, labelContent: React.createElement(React.Fragment, null, "Referred By") },
                                                React.createElement(Input, { disabled: true, value: this.state.referralText }))),
                                this.props.eventReferral
                                    &&
                                        React.createElement(Grid.Column, null,
                                            React.createElement(FieldWithErrorDisplay, { disabled: disabled, errorPath: "/referredBy", errors: this.state.errors, labelContent: React.createElement(React.Fragment, null, "Referred By") },
                                                React.createElement(Input, { disabled: true, value: this.state.referralText })))),
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, null,
                                    React.createElement(FieldWithErrorDisplay, { disabled: disabled, errorPath: "/email", errors: this.state.errors, labelContent: React.createElement(React.Fragment, null, "Email"), required: true },
                                        React.createElement(Input, { placeholder: 'alfred@nobel.com', type: 'email', onChange: this.onEmailChange, value: this.state.email }))),
                                this.props.includePassword &&
                                    React.createElement(Grid.Column, null,
                                        React.createElement(FieldWithErrorDisplay, { disabled: disabled, errorPath: "/password", errors: this.state.errors, labelContent: React.createElement(React.Fragment, null, "Password"), required: true },
                                            React.createElement(Input, { type: 'password', onChange: this.onPasswordChange, value: this.state.password }))),
                                React.createElement(Grid.Column, null,
                                    React.createElement(FieldWithErrorDisplay, { disabled: disabled, errorPath: "/phone", errors: this.state.errors, labelContent: React.createElement(React.Fragment, null,
                                            "Phone ",
                                            React.createElement(Help, null, "Provided to the shipping company in case of delivery issues")), required: true },
                                        React.createElement(Input, { onChange: this.onPhoneChange, value: this.state.phone })))),
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, null,
                                    React.createElement(FieldWithErrorDisplay, { disabled: disabled, errorPath: "/organization", errors: this.state.errors, labelContent: React.createElement(React.Fragment, null, "Organization"), required: true },
                                        React.createElement(Input, { onChange: this.onOrganizationChange, value: this.state.organization }))),
                                this.props.categoryInput &&
                                    React.createElement(Grid.Column, null,
                                        React.createElement(FieldWithErrorDisplay, { disabled: disabled, errorPath: "/category", errors: this.state.errors, labelContent: React.createElement(React.Fragment, null, "Organization Type"), required: true },
                                            React.createElement(Select, { placeholder: 'Select...', onChange: this.onCategoryChange, options: [
                                                    {
                                                        text: 'University',
                                                        value: 'UNIVERSITY'
                                                    },
                                                    {
                                                        text: 'Government Lab',
                                                        value: 'GOVT_LAB'
                                                    },
                                                    {
                                                        text: 'Nonprofit Research Institute',
                                                        value: 'NONPROFIT_INST'
                                                    },
                                                    {
                                                        text: 'Research Hospital',
                                                        value: 'RESEARCH_HOSPITAL'
                                                    },
                                                    {
                                                        text: 'Company',
                                                        value: 'COMPANY'
                                                    },
                                                ], search: true, value: this.state.category }))),
                                React.createElement(Grid.Column, null,
                                    React.createElement(FieldWithErrorDisplay, { disabled: disabled, errorPath: "/researchGroup", errors: this.state.errors, labelContent: React.createElement(React.Fragment, null, "Research Group"), required: false },
                                        React.createElement(Input, { onChange: this.onResearchGroupChange, value: this.state.researchGroup })))))),
                    React.createElement(Header, null, "Shipping Info"),
                    React.createElement("div", { className: 'field-group' },
                        React.createElement(Grid, { columns: 3 },
                            React.createElement(AddressEditForm, { address: this.state.shippingAddress, disabled: disabled, errorPathPrefix: '/shippingAddress', errors: this.state.errors, setAddressState: this.setShippingAddressState }))),
                    React.createElement(Header, null, "Billing Info"),
                    React.createElement(Checkbox, { disabled: disabled, label: 'Use Shipping Address', onChange: this.onUseShippingForBillingChange, checked: this.state.useShippingForBilling }),
                    React.createElement("div", { className: 'field-group billing-info' },
                        React.createElement(Grid, { columns: 3 },
                            !this.state.useShippingForBilling &&
                                React.createElement(AddressEditForm, { address: this.state.billingAddress, disabled: disabled, errorPathPrefix: '/billingAddress', errors: this.state.errors, setAddressState: this.setBillingAddressState }),
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, null,
                                    React.createElement(FieldWithErrorDisplay, { disabled: disabled, errorPath: "/billingEmail", errors: this.state.errors, labelContent: React.createElement(React.Fragment, null,
                                            "Billing Email ",
                                            React.createElement(Help, null, "e.g. your purchasing agent")), required: true },
                                        React.createElement(Input, { onChange: this.onBillingEmailChange, value: this.state.billingEmail, type: 'email' }))),
                                React.createElement(Grid.Column, null,
                                    React.createElement(FieldWithErrorDisplay, { disabled: disabled, errorPath: "/billingPhone", errors: this.state.errors, labelContent: React.createElement(React.Fragment, null,
                                            "Billing Phone ",
                                            React.createElement(Help, null, "e.g. your purchasing agent")), required: true },
                                        React.createElement(Input, { onChange: this.onBillingPhoneChange, value: this.state.billingPhone })))))),
                    this.props.legalInput &&
                        React.createElement(Grid, { columns: 3 },
                            React.createElement(Grid.Column, null,
                                React.createElement(FieldWithErrorDisplay, { errors: this.state.errors, errorPath: "/legal/terms", labelContent: 'Terms', required: true },
                                    React.createElement(Checkbox, { disabled: disabled, label: {
                                            children: React.createElement(React.Fragment, null,
                                                "I agree to the",
                                                ORIGIN === "mi" ? React.createElement("a", { href: "https://www.molecularinstruments.com/terms", target: '_blank' }, " Terms") :
                                                    React.createElement("a", { href: "https://www.hcrimaging.com/legal/terms", target: '_blank' }, " Terms"))
                                        }, onChange: this.onAcceptedTermsChange, value: this.state.acceptedTerms ? 1 : 0 }))))),
            React.createElement(ErrorDisplay, { errors: this.state.errors, errorPath: '/' }),
            this.state.success
                && React.createElement(Message, { success: true },
                    React.createElement(Message.Header, null, this.props.successHeader),
                    this.props.successMessage),
            React.createElement(Button, { disabled: disabled, icon: this.props.buttonIcon, label: this.props.buttonLabel, labelPosition: 'left', onClick: this.onSubmit, positive: true }));
    };
    return ProfileEditForm;
}(React.PureComponent));
export default ProfileEditForm;
//# sourceMappingURL=ProfileEditForm.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/ProfileEditForm.js
// module id = 315
// module chunks = 0